module.exports = __webpack_public_path__ + "static/media/avast-vince-formule.f56cbcf5.jpg";